import React from 'react'
import { IconBulb } from '@tabler/icons-react'

import { Banner } from '@/components/banners/Banner'
import { Button } from '@/components/buttons/Button'

export const ReorderDecklist = ({ reorderRecommend, useInsightOrder, dismissInsight }) => {
  if (!reorderRecommend) {
    return null
  }

  return (
    <Banner
      informative
      icon={<IconBulb className="icon-svg" />}
      header="Balto Insight Recommendation"
    >
      <p>Balto recommends rearranging some Decklist Items for better win performance.</p>
      <div className="flex-align-center medium-gap">
        <Button text onClick={() => useInsightOrder()}>
          Rearrange Decklist Items
        </Button>
        <Button text onClick={() => dismissInsight()}>
          Dismiss
        </Button>
      </div>
    </Banner>
  )
}
